import { Site } from '@envato/foundation-types'

import * as React from 'react'
import { connect } from 'react-redux'

import { IRootState } from '../../../common/reducers'
import { ICategoryPageResult } from '../../../common/reducers/categoryPage'
import {
  IEnhancedLocation,
  ILocationParams
} from '../../../common/reducers/reactRouterLocation'

import { hasFeature } from '../../../common/utils/features'
import { getSearchLocationParams } from '../../../common/utils/location'
import makeSearchLink from '../../../common/utils/location/makeSearchLink'
import { makeLink } from '../../../common/utils/urlHelper'
import { IOwnProps } from '../../../typings/pageBlocks'
import { IPageComponent } from '../../../typings/pageComponent'
import CategoryPage from '../../pages/category'
import { decorateBlocks } from '../../../common/utils/pageBlocks'

import { IExperimentsState } from '../../../common/reducers/experiments'

interface IStateProps extends ICategoryPageResult {
  location: IEnhancedLocation
  isLoading: boolean
  dataRequestFailed?: boolean
  currentSite: Site
  locationParams: ILocationParams
  makeSearchLink: (params: ILocationParams, currentSite?: Site) => string
  experiments: IExperimentsState
  experimentsReady: boolean
}

const mapStateToProps = (
  state: IRootState,
  ownProps: IOwnProps
): IStateProps => {
  const {
    categoryPage: {
      metadata,
      topArticle,
      category,
      blocks,
      blocksB,
      blocksC,
      blocksD,
      isLoading,
      dataRequestFailed
    },
    experiments
  } = state

  const { location } = state.router
  const { currentSite } = state.common
  const { experimentsReady } = state.experiments
  const decoratedBlocks = decorateBlocks(state, blocks)
  const decoratedBlocksB = decorateBlocks(state, blocksB)
  const decoratedBlocksC = decorateBlocks(state, blocksC)
  const decoratedBlocksD = decorateBlocks(state, blocksD)

  const newRoutesEnabled = hasFeature(
    'routes:new',
    currentSite,
    location,
    experiments
  )

  return {
    metadata,
    topArticle,
    category,
    blocks: decoratedBlocks,
    blocksB: decoratedBlocksB,
    blocksC: decoratedBlocksC,
    blocksD: decoratedBlocksD,
    isLoading,
    dataRequestFailed,
    location,
    currentSite,
    makeSearchLink: newRoutesEnabled ? makeSearchLink : makeLink,
    experiments,
    experimentsReady,
    locationParams: getSearchLocationParams({
      location,
      currentSite,
      experiments,
      routeMatch: ownProps.match
    })
  }
}

export type Props = IOwnProps & IStateProps

const createCategoryPageContainer = (component: React.ComponentType<Props>) => {
  const pageComponent: IPageComponent<Props> = component as IPageComponent<
    Props
  >

  return connect<IStateProps, null, IOwnProps, IRootState>(mapStateToProps)(
    pageComponent
  )
}

export default createCategoryPageContainer(CategoryPage)
